import { fromJS } from 'immutable'

export default fromJS({
  questions: {
    noAlt: 'ไม่มีข้อความทางเลือกสำหรับรูปภาพนี้',
    noAnswers: 'ไม่มีตัวเลือกคำตอบ โปรดคลิกถัดไปเพื่อดำเนินการต่อ.',
    placeholder: 'โปรดระบุ...',
    pleaseSelect: 'โปรดเลือก...',
    rotateLandscape: 'กรุณาปิดล็อกการหมุนหน้าจอบนโทรศัพท์ของคุณ แล้วหมุนเป็นแนวนอนเพื่อดำเนินการต่อ',
    rotatePortrait: 'หมุนโทรศัพท์ของคุณจากแนวนอนเป็นแนวตั้งเพื่อดำเนินการต่อ',
    ir: {
      selectWebCam: "เลือกเว็บแคม (ถ้ามี) หรือคลิก 'เบราว์' เพื่ออัปโหลดจากอุปกรณ์ของคุณ",
      noWebCam: 'ไม่พบเว็บแคม',
      accessCamUpload: 'เข้าถึงกล้อง/อัปโหลด',
      browse: 'เบราว์',
      uploadPhoto: 'อัปโหลดรูปภาพ',
      camera: 'กล้องบนเว็บ',
      instead: 'แทน',
      capture: 'จับภาพ',
      somethingWrong: 'ขออภัย มีบางอย่างผิดพลาด โปรดลองใหม่อีกครั้งในภายหลัง.',
      couldntRead: 'ขออภัย เราไม่สามารถอ่านโค้ดได้!',
      couldntProcess: 'ขออภัย เราไม่สามารถประมวลผลภาพของคุณได้!',
      inValidCode: 'Please, submit the valid code',
      moveOn: 'โปรดลองอีกครั้งหรือส่งรูปภาพของคุณและดำเนินการต่อ',
      tryAgain: 'โปรดลองอีกครั้ง',
      dataReceived: 'ได้รับข้อมูลแล้ว!',
      enterManually: 'โปรดลองอีกครั้งหรือป้อนข้อมูลด้วยตนเองด้านล่าง',
      positionQR: 'โปรดจัดตำแหน่งรหัส QR ไว้ด้านหน้ากล้องของคุณเพื่อให้พอดีกับกรอบสีแดงหรืออัปโหลดจากคอมพิวเตอร์ของคุณ',
      positionQRMobile: 'โปรดจัดตำแหน่งรหัส QR ไว้ด้านหน้ากล้องของคุณหรืออัปโหลดจากอุปกรณ์ของคุณ',
      analyzing: 'กำลังวิเคราะห์รูปภาพ โปรดรอสักครู่',
      submit: 'ส่ง',
      startOver: 'เริ่มต้นใหม่',
      allDone: 'เสร็จเรียบร้อย!',
      cantAnalyze:
        'โปรดทราบ - เราไม่สามารถแสดงภาพนี้ได้ โปรดลองส่งอีกครั้งหรือเลือกรูปภาพในรูปแบบทั่วไป (JPG, PNG, GIF, BMP)',
      wrongFormat:
        'ขออภัย เราไม่รองรับรูปแบบไฟล์นี้ โปรดอัปโหลดรูปภาพในประเภทที่รองรับ (JPG, PNG, GIF, BMP, TIF, PDF, SVG)'
    },
    vr: {
      noWebCam: 'ไม่พบเว็บแคม',
      uploadVideo: 'อัปโหลดวิดีโอ',
      skip: 'ข้ามหรือไม่?',
      accessCamUpload: 'เข้าถึงกล้อง/อัปโหลด',
      browse: 'เบราว์',
      instead: 'แทน',
      or: 'หรือ',
      stopRecording: 'หยุดบันทึก',
      willBeStopped: 'การบันทึกจะหยุดที่ <b>5 นาที</b>',
      stopOnDone: 'หยุดบันทึกเมื่อคุณทำเสร็จแล้ว!',
      record: 'บันทึก',
      somethingWrong: 'ขออภัย มีบางอย่างผิดพลาด โปรดลองใหม่อีกครั้งในภายหลัง',
      dataReceived: 'ได้รับข้อมูลแล้ว!',
      microphone: 'Microfonul',
      camera: 'กล้องบนเว็บ',
      selectMicrophone: 'เลือกไมโครโฟนของคุณ',
      selectCam: 'เลือกกล้องบนเว็บของคุณ',
      submit: 'ส่ง',
      upload: 'อัปโหลดใหม่',
      playback: 'เล่นย้อน',
      stopPlayback: 'หยุดการเล่น',
      startOver: 'เริ่มต้นใหม่',
      allDone: 'เสร็จเรียบร้อย!',
      alternativeRecordSpan:
        'โปรดอัปโหลดคลิปวิดีโอจากอุปกรณ์คอมพิวเตอร์ของคุณ ในอีกทางหนึ่ง คุณสามารถบันทึกวิดีโอด้วยเว็บแคม&nbsp;',
      alrenativeRecordHref: 'คุณสามารถบันทึกวิดีโอด้วยเว็บแคม',
      cantAnalyze:
        'โปรดทราบ - เราไม่สามารถแสดงวิดีโอนี้ได้ โปรดลองส่งอีกครั้งหรือเลือกวิดีโอในรูปแบบทั่วไป (MP4, M4V, WEBPM)',
      wrongFormat:
        'ขออภัย เราไม่รองรับรูปแบบไฟล์นี้ โปรดอัปโหลดวิดีโอในประเภทที่รองรับ (MP4, AVI, M4V, WEBPM, MOV, MKV, MPG, WMV)'
    },
    cjc: {
      choose: 'เลือก',
      pleaseChoose: 'โปรดเลือก',
      this: 'นี้',
      one: 'หนึ่ง',
      myChoice: 'ตัวเลือกของฉัน'
    },
    hm: {
      addComment: 'โปรดเพิ่มความคิดเห็นด้านล่าง',
      commentMandatoryPlaceHolder: 'โปรดเพิ่มความคิดเห็นที่จำเป็น ...',
      commentOptionalPlaceHolder: 'โปรดเพิ่มความคิดเห็นหากมี ...',
      dragPin: 'ลากเพื่อเปลี่ยนตำแหน่ง (คลิก/แตะค้างเพื่อการยึดตำแหน่งที่แม่นยำ)',
      removePin: 'ลากออกไปด้านนอกภาพเพื่อลบ',
      editComment: 'คลิก/แตะหมุดเพื่อแก้ไขความคิดเห็น',
      addPin: 'โปรดลากหมุดจากแผงด้านล่างและวางในจุดที่คุณเลือกบนภาพ',
      addPins: 'โปรดลากหมุดจากแผงด้านล่างและวางในจุดที่คุณเลือกบนภาพ',
      leavePins: (minPoints, maxPoints) =>
        `โปรดวางหมุดแต่ละประเภทอย่างน้อย ${minPoints} ชิ้นแต่ไม่เกิน ${maxPoints} ชิ้น`,
      leavePinsAny: (minPoints, maxPoints) =>
        `โปรดวางหมุดแต่ละประเภทอย่างน้อย ${minPoints} ชิ้นแต่ไม่เกิน ${maxPoints} ชิ้น`,
      leavePinsPerPage: (minPoints, maxPoints) => `โปรดวางหมุดอย่างน้อย ${minPoints} ชิ้นแต่ไม่เกิน ${maxPoints} ชิ้น`,
      leavePinsWithOff: maxPoints => `โปรดอย่าเหลือหมุดแต่ละประเภทเกิน ${maxPoints} หมุด หรือคลิกถัดไปเพื่อข้าม `,
      leavePinsWithOffAny: maxPoints => `โปรดอย่าเหลือหมุดแต่ละประเภทเกิน ${maxPoints} หมุด หรือคลิกถัดไปเพื่อข้าม`,
      leavePinsPerPageWithOff: maxPoints => `โปรดอย่าเหลือหมุดเกิน ${maxPoints} หมุด หรือคลิกถัดไปเพื่อข้าม`,
      leavePinWithOff: `โปรดอย่าเหลือหมุดแต่ละประเภทเกิน 1 หมุด หรือคลิกถัดไปเพื่อข้าม.`,
      leavePinWithOffAny: `โปรดอย่าเหลือหมุดแต่ละประเภทเกิน 1 หมุด หรือคลิกถัดไปเพื่อข้าม`,
      leavePinPerPageWithOff: 'โปรดอย่าเหลือหมุดเกิน 1 หมุด หรือคลิกถัดไปเพื่อข้าม',
      leaveExactlyPin: `โปรดเหลือหมุดแต่ละประเภท 1 หมุด`,
      leaveExactlyPinAny: `โปรดเหลือหมุดแต่ละประเภท 1 หมุด`,
      leaveExactlyPinPerPage: 'โปรดเหลือหมุด 1 หมุด',
      leaveExactlyPins: maxPoints => `โปรดเหลือหมุดแต่ละประเภท ${maxPoints} หมุด`,
      leaveExactlyPinsAny: maxPoints => `โปรดเหลือหมุดแต่ละประเภท ${maxPoints} หมุด`,
      leaveExactlyPinsPerPage: maxPoints => `โปรดเหลือหมุด ${maxPoints} หมุด`,
      leaveComment: 'พิมพ์ด้านล่างของภาพเพื่อแสดงความคิดเห็น',
      noAnswers: 'ไม่มีตัวเลือกคำตอบ โปรดคลิกถัดไปเพื่อดำเนินการต่อ',
      outOfPins: 'คุณไม่มีหมุดแล้ว',
      pinsBehavior: 'เมื่อคุณเลื่อนผ่านรูปภาพ คุณจะเห็นพื้นที่ๆ ถูกไฮไลต์ด้วยการปักหมุดเพียงครั้งเดียว',
      clusters: 'คุณจะวางหมุดได้ในพื้นที่ๆ ถูกไฮไลต์เหล่านี้เท่านั้น',
      contentAware: 'คุณสามารถปักหมุดภายนอกหรือภายในพื้นที่ๆ ถูกไฮไลต์นี้ได้'
    },
    mp: {
      expand_note: 'โปรดวางเมาส์เหนือภาพหรือคลิกที่ภาพเพื่อขยาย',
      rb_note: rows => `โปรดเลือกคำตอบเพียง 1 ข้อเท่านั้นต่อรายการ${rows ? 'ด้านล่าง' : ''}`,
      cb_note: (min, max, rows) => {
        if (1 === min && 5000 === max) {
          return 'เลือกทุกข้อที่เกี่ยวข้อง:'
        } else if (min === max) {
          return `โปรดเลือกคำตอบเพียง ${min} ข้อเท่านั้นต่อรายการ${rows ? 'ด้านล่าง' : ''}:`
        } else if (min > 0 && max < 5000) {
          return `กรุณาเลือกคำตอบอย่างน้อย ${min} แต่ไม่เกิน ${max} ต่อรายการ${rows ? 'ด้านล่าง' : ''}:`
        } else if (5000 === max && min > 0) {
          return `กรุณาเลือกคำตอบอย่างน้อย ${min} ต่อรายการ${rows ? 'ด้านล่าง' : ''}:`
        } else if (0 === min && max < 5000) {
          return `กรุณาเลือกตำตอบไม่เกิน ${max} ต่อรายการ${rows ? 'ด้านล่าง' : ''}:`
        } else {
          return 'เลือกทุกข้อที่เกี่ยวข้อง:'
        }
      }
    },
    sh: {
      note: 'คลิกผลิตภัณฑ์เพื่อขยายและเพิ่มลงในรถเข็นแบบเสมือนของคุณหากคุณจะซื้อสินค้าดังกล่าวในร้านค้า',
      amazonNote: 'คลิกที่ผลิตภัณฑ์เพื่อทำการขยายและเพิ่มลงในตะกร้าสินค้าเสมือนของคุณ',
      fullCart: 'รถเข็นของคุณเต็มแล้ว!',
      qty: 'จำนวน',
      addToCart: 'เพิ่มลงในรถเข็น',
      added: 'ADDED',
      deleteFromCart: 'ลบ',
      each: 'แต่ละ',
      items: 'รายการ',
      emptyCard: 'รถเข็นของคุณว่างเปล่า',
      total: 'รถเข็น',
      fullscreen: 'Fullscreen mode',
      closeFullscreen: 'Exit fullscreen',
      clearCart: 'ล้างรถเข็นให้โล่ง',
      backToStore: 'กลับไปยังร้านค้า',
      na: 'ไม่มีข้อใดถูก',
      next: 'ต่อไป',
      shelfError: (count, products) =>
        `There is no place for ${count !== 1 ? 'these' : 'this'} product${
          count !== 1 ? 's' : ''
        } on the shelves: ${products}!`,
      maxCartCountError: max => `โปรดเพิ่มสินค้าไม่เกิน ${max} รายการในรถเข็นของคุณ `,
      scrollError: `โปรดเลื่อนไปทางซ้ายสุดและขวาสุดเพื่อทำแบบสำรวจต่อไป `,
      maxSpentError: max => `โปรดใช้จ่ายไม่เกิน ${max} `,
      maxProductCountError: max => `โปรดเพิ่มจำนวนไม่เกิน ${max} ลงในรถเข็นของคุณสำหรับสินค้าแต่ละรายการ `
    },
    rb: {
      note: 'โปรดเลือกเพียง 1 รายการ:'
    },
    vo: {
      note: 'โปรดดูวิดีโอจนจบ\n'
    },
    cb: {
      note: (min, max) => {
        if (1 === min && 5000 === max) {
          return 'เลือกทุกข้อที่เกี่ยวข้อง:'
        } else if (min === max) {
          return `โปรดเลือกรายการใด ๆ ${min} รายการ:`
        } else if (min > 0 && max < 5000) {
          return `โปรดเลือกอย่างน้อย ${min} รายการแต่ไม่เกิน ${max} รายการต่อแถว:`
        } else if (5000 === max && min > 0) {
          return `โปรดเลือกอย่างน้อย ${min} รายการ:`
        } else if (0 === min && max < 5000) {
          return `โปรดเลือกไม่เกิน ${max} รายการ:`
        } else {
          return 'เลือกทุกข้อที่เกี่ยวข้อง:'
        }
      }
    },
    oe: {
      na: 'ไม่สามารถใช้ได้',
      note: (min, max, optional) => {
        if (min === max) {
          return `โปรดพิมพ์${1 !== min ? 'ตัวอักษรใด ๆ' : 'เพียง'} ${min} ตัวอักษร${optional ? ' (หากมี)' : ''}:`
        } else if (min > 0 && max < 5000) {
          return `โปรดพิมพ์อย่างน้อย ${min} ตัวอักษร แต่ไม่เกิน ${max}${optional ? ' (หากมี)' : ''}:`
        } else if (5000 === max && min > 0) {
          return `โปรดพิมพ์อย่างน้อย ${min} ตัวอักษร${optional ? ' (หากมี)' : ''}:`
        } else if (0 === min && max < 5000) {
          return `โปรดพิมพ์ไม่เกิน ${max} ตัวอักษร${optional ? ' (หากมี)' : ''}:`
        } else {
          return ''
        }
      }
    },
    oex: {
      note: 'โปรดกรอกข้อมูลในช่องต่อไปนี้:'
    },
    mx: {
      note: 'โปรดเลื่อนแถบเลื่อนที่ไฮไลต์เพื่อดำเนินการต่อ',
      dragSlider: 'ลากไปทางซ้ายหรือขวาเพื่อตอบ'
    },
    psc: {
      dragLeftRight: 'ลากไปทางซ้ายหรือขวาเพื่อตอบ'
    },
    ps: {
      note: value => `โปรดแบ่ง ${value} ให้กับรายการด้านล่าง`,
      allDone: `เสร็จเรียบร้อย!`,
      total: `Total:`,
      dragSlider: 'ลากไปทางซ้ายหรือขวาเพื่อตอบ'
    },
    cx: {
      note: 'เริ่มพิมพ์คำตอบของคุณเพื่อเลื่อนโดยอัตโนมัติหรือเลือกด้วยตนเอง'
    },
    ro: {
      note: 'ลากขึ้นหรือลงเพื่อจัดลำดับใหม่:'
    },
    md: {
      note1: 'โปรดคลิก/แตะรายการที่คุณเลือกเป็นอันดับแรก<br/>คลิก/แตะอีกครั้งเพื่อล้างตัวเลือก',
      note2: 'ตอนนี้ โปรดคลิก/แตะรายการที่คุณเลือกเป็นอันดับสุดท้าย<br/>คลิก/แตะอีกครั้งเพื่อล้างตัวเลือก',
      note3: 'ขอบคุณ! ไปที่คำถามถัดไปหรือคลิก/แตะรายการที่ไม่ได้เลือกเพื่อเริ่มต้นใหม่'
    },
    aro: {
      note: 'โปรดเลือกหนึ่งรายการจากแต่ละคู่:'
    },
    wd: {
      note: 'ตรวจสอบให้แน่ใจว่าค่าด้านหลังแต่ละค่านั้นมากกว่าค่าก่อนหน้า.'
    },
    emd: {
      note: 'โปรดดูวิดีโอจนจบ\n',
      noAnswers: 'ไม่มีตัวเลือกคำตอบ โปรดคลิกถัดไปเพื่อดำเนินการต่อ',
      start: 'คลิกค้างเพื่อเริ่มต้น',
      resume: 'คลิกค้างเพื่อเริ่มต่อ',
      continue: 'คุณพร้อมแล้ว! <br /> คลิกถัดไปเพื่อดำเนินการต่อ',
      continueMobile: 'คุณพร้อมแล้ว! <br /> คลิกที่นี่เพื่อดำเนินการต่อ',
      training: {
        session: 'Utbildningssession',
        note: 'โปรดทำการฝึกอบรมให้เสร็จสิ้น',
        moveLeft: 'โปรดลากหน้าปัดไปทางซ้ายสุด',
        moveBottom: 'โปรดลากหน้าปัดไปทางล่างสุด',
        moveRight: 'ตอนนี้ โปรดลากหน้าปัดไปทางขวาสุด',
        moveTop: 'ตอนนี้ โปรดลากหน้าปัดไปทางบนสุด',
        success: 'เยี่ยมมาก!'
      }
    },
    sft: {
      noAnswers: 'ไม่มีตัวเลือกคำตอบ โปรดคลิกถัดไปเพื่อดำเนินการต่อ',
      note: 'โปรดตอบโดยเร็วที่สุดด้วยคำตอบที่รู้สึกว่าถูกต้องตามสัญชาตญาณ',
      finish: 'เสร็จแล้ว! <br/> กรุณาคลิกถัดไปเพื่อดำเนินการต่อ',
      training: {
        start:
          '<p>คำถามนี้จะแสดงคำต่าง ๆ ให้คุณเห็นอย่างรวดเร็วและคุณต้องใช้สมาธิ ' +
          'คุณจะต้องตอบสนองอย่างรวดเร็วเพื่อตอบคำถาม </p> <p>พร้อมฝึกไหม?</p>',
        step1: (touch, mouse, key) =>
          touch
            ? `แตะ "{buttonLeft}"`
            : (mouse ? `คลิก  "{buttonLeft}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `กดปุ่ม "{keyBtnLeft}"` : ''),
        step2: (touch, mouse, key) =>
          touch
            ? `แตะ "{buttonRight}"`
            : (mouse ? `คลิก  "{buttonRight}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `กดปุ่ม "{keyBtnRight}"` : ''),
        fail: () => 'ช้าเกินไป',
        success: () => 'ยอดเยี่ยม!',
        finish: () =>
          '<p><strong> ยอดเยี่ยม!</strong></p><p>Pโปรดยืนยันว่าคุณจะไม่เสียสมาธิในอีก 2-3 นาทีข้างหน้า </p><p>คลิกถัดไปเพื่อเริ่มเมื่อพร้อม</p>'
      },
      buttons: {
        start: 'เริ่มต้น',
        yesno: {
          left: 'ใช่',
          right: 'ไม่'
        },
        matches: {
          left: 'จับคู่',
          right: 'จับคู่ไม่ได้'
        },
        fits: {
          left: 'เข้ากันได้',
          right: 'เข้ากันไม่ได้'
        },
        thumbs: {
          left: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsUp"></i>',
          right: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsDown"></i>'
        }
      }
    }
  }
})
